// dashboard/AlertBanner.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AlertBannerProps {
  pendingSignatures: number;
  firstDocumentId?: string;
  waitingDays?: number;
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  pendingSignatures,
  firstDocumentId = '1550661',
  waitingDays = 2
}) => {
  const navigate = useNavigate();

  if (pendingSignatures === 0) {
    return null;
  }

  return (
    <div className="mb-24 rounded-xl bg-gradient-to-r from-orange-50 to-pink-50 border-l-4 border-orange-500 p-20 shadow-sm">
      <div className="flex items-start justify-between flex-wrap gap-16">
        {/* Left side - Icon + Message */}
        <div className="flex items-start gap-16">
          <AlertTriangle className="w-24 h-24 text-orange-500 flex-shrink-0 mt-2" strokeWidth={2} />
          <div>
            <h3 className="text-gray-900 font-semibold text-16 mb-6">
              Document requires your signature
            </h3>
            <p className="text-gray-600 text-14 leading-relaxed">
              Document #{firstDocumentId} has been waiting for {waitingDays} {waitingDays === 1 ? 'day' : 'days'}. Sign now to complete the process.
            </p>
          </div>
        </div>

        {/* Right side - Buttons */}
        <div className="flex items-center gap-12 flex-shrink-0">
          <button
            onClick={() => navigate('/signature-documents')}
            className="bg-gradient-to-r from-brand-purple to-brand-pink text-white px-20 py-10 rounded-lg font-medium text-14 hover:shadow-lg transition-all duration-200 hover:scale-105"
          >
            Sign Document
          </button>
          <button
            onClick={() => navigate('/signature-documents')}
            className="bg-white border border-gray-300 text-gray-700 px-20 py-10 rounded-lg font-medium text-14 hover:bg-gray-50 transition-all duration-200"
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};
